import { PublicApiClient } from "./PublicApiClient";
import { ValueOf } from "../../utils/utils";

export const SOFTWARE_TYPES = {
    TRUTOPS: "TruTops",
    TRUTOPS_FAB: "TruTops Fab",
    TRUTOPS_CELL: "TruTops Cell",
    TRUTOPS_BOOST: "TruTops Boost",
    TRUTOPS_WELD: "TruTops Weld",
    PROGRAMMING_TUBE: "Programming Tube"
};

export type SoftwareType = ValueOf<typeof SOFTWARE_TYPES>;

export interface Software {
    softwareType: SoftwareType;
    softwareModule: string;
    productNo: string;
}

export const getSoftwareTypes = (softwares: Software[]): string[] => {
    return Array.from(new Set(softwares.map((software) => software.softwareType)));
};

export const getSoftwareModulesByType = (softwares: Software[], softwareType: string): string[] => {
    return Array.from(
        new Set(softwares.filter((software) => software.softwareType === softwareType).map((software) => software.softwareModule))
    );
};

export const getSoftwareProductNumber = (softwares: Software[], softwareType: string, softwareModule: string): string => {
    const software = softwares.find(
        (software) => software.softwareType === softwareType && software.softwareModule === softwareModule
    );
    return software ? software.productNo : "";
};

export const getSoftwares = async (apiClient: PublicApiClient): Promise<Software[]> => {
    return apiClient.request<Software[]>("/servicecall/getsoftware", {
        mockResponse: mockSoftwares
    });
};

export const mockSoftwares: Software[] = [
    {
        softwareType: "TruTops",
        softwareModule: "CAD",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops Fab",
        softwareModule: "Storage",
        productNo: "9TWDEDEMOS612"
    },
    {
        softwareType: "TruTops",
        softwareModule: "Laser",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops",
        softwareModule: "Tube",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops",
        softwareModule: "Punch",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops",
        softwareModule: "Bend",
        productNo: "9TWDEDEMOS415"
    },
    {
        softwareType: "TruTops Cell",
        softwareModule: "TruTops Cell",
        productNo: "9TWDEDEMOS185"
    },
    {
        softwareType: "TruTops Fab",
        softwareModule: "Quickjob",
        productNo: "9TWDEDEMOS612"
    },
    {
        softwareType: "TruTops Boost",
        softwareModule: "HomeZone",
        productNo: "9TWDEDEMOS872"
    },
    {
        softwareType: "TruTops Boost",
        softwareModule: "Design",
        productNo: "9TWDEDEMOS872"
    },
    {
        softwareType: "TruTops Boost",
        softwareModule: "Cut",
        productNo: "9TWDEDEMOS872"
    },
    {
        softwareType: "TruTops Boost",
        softwareModule: "Bend",
        productNo: "9TWDEDEMOS872"
    },
    {
        softwareType: "TruTops Weld",
        softwareModule: "TruTops Weld",
        productNo: "9TWDEDEMOS901"
    },
    {
        softwareType: "Programming Tube",
        softwareModule: "Programming Tube",
        productNo: "9TWDEDEMOS873"
    }
];
